import { CONTAINER_PARTS } from './containerParts';
import type { ContainerStyleConfig } from './types';

export const CONTAINER_STYLE_CONFIG: ContainerStyleConfig = {
  parts: CONTAINER_PARTS,
  baseStyle: {
    container: {
      display: 'flex',
      flexDirection: 'column',
      background: 'page.surface',
    },
    containerHeader: {
      paddingX: 1.5,
      background: 'page.surface',
      display: 'flex',
      flex: '0 0 auto',
      borderBottom: '1px solid',
      borderColor: 'separator.divider',
    },
    containerTitle: {
      fontFamily: 'default',
      fontWeight: 'heavy',
      margin: 0,
      size: 'lg',
    },
    containerBody: {
      paddingX: 1.5,
      background: 'page.surface',
      display: 'flex',
    },
    containerFooter: {
      paddingX: 1.5,
      background: 'page.surface',
      display: 'flex',
      flex: '0 0 auto',
      borderTop: '1px solid',
      borderColor: 'separator.divider',
    },
  },
  variants: {
    default: {
      container: {
        border: '1px solid',
        borderColor: 'separator.border',
        borderRadius: 'lg',
      },
      containerHeader: {
        borderTopRadius: 'lg',
      },
      containerFooter: {
        borderBottomRadius: 'lg',
      },
    },
    borderless: {
      container: {
        border: 'none',
      },
      containerHeader: {
        borderTopRadius: 'none',
      },
      containerFooter: {
        borderBottomRadius: 'none',
      },
    },
  },
  sizes: {
    sm: {
      containerHeader: {
        paddingY: 1,
      },
      containerBody: {
        paddingY: 1,
      },
      containerFooter: {
        paddingY: 1,
      },
    },
    md: {
      containerHeader: {
        paddingY: 1.25,
      },
      containerBody: {
        paddingY: 1.25,
      },
      containerFooter: {
        paddingY: 1.25,
      },
    },
    lg: {
      containerHeader: {
        paddingY: 1.5,
      },
      containerBody: {
        paddingY: 1.5,
      },
      containerFooter: {
        paddingY: 1.5,
      },
    },
  },
  defaultProps: {
    size: 'md',
    variant: 'default',
  },
};
